import { ListingType } from 'algolia-api/types/ListingType';
import { StaffTypeFilter } from 'algolia-api/types/StaffTypeFilter';

export const SEARCH_PAGE_SIZE = 20;
export const CMS_PAGE_TYPE_MAP = {
  POST: 'Post',
  PAGE: 'Page',
};

export const NO_FILTER_SENTINEL = '_NONE_';

export type DisplayedType = ListingType | StaffTypeFilter;

export const IDEALIST_TIME_ZONE = 'America/New_York';

export const SEARCH_HIT_IMAGE_WIDTH = 120;
export const SEARCH_HIT_IMAGE_WIDTH_SMALL = 80;

export const SEARCH_HIT_IMAGE_HEIGHT = 120;
export const SEARCH_HIT_IMAGE_HEIGHT_SMALL = 80;
